<template>
  <div class="control">
    <div class="control-item" @click="addControl('img')">
      <div class="control-item-title">
        图片
      </div>
    </div>
    <div class="control-item" @click="addControl('video')">
      <div class="control-item-title">
        视频
      </div>
    </div>
    <div class="control-item" @click="addControl('streaming')">
      <div class="control-item-title">
        流媒体
      </div>
    </div>
    <div class="control-item" @click="addControl('webPage')">
      <div class="control-item-title">
        网站
      </div>
    </div>
    <div class="control-item" @click="addControl('subtitle')">
      <div class="control-item-title">
        文字
      </div>
    </div>
    <div class="control-item" @click="addControl('hdmin')">
      <div class="control-item-title">
        HDMI
      </div>
    </div>
    <div class="control-item" @click="addbackground">
      <div class="control-item-title ">
        背景
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'control',
    methods: {
      addControl(data) {
        this.$emit('addControl', data)
      },
      addbackground() {
        this.$emit('addbackground')
      },
    },
  }
</script>

<style scoped lang="scss">
  @import "../../public/static/css/app";

  .control {
    position: absolute;
    height: 50px;
    width: 100%;
    bottom: 0;
    left: 0;
    background: #ffffff;
    z-index: 10;
    display: flex;
    border-top: 1px solid $uni-border-bottom-color;

    .control-item {
      flex: 1;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      .control-item-title {
        font-size: 14px;
      }
    }
  }
</style>
